import React from 'react';
import MenuItemModal from '../../components/MenuItemModal/MenuItemModal';

/**
 * Our Menu entry point for the shared product detail dialog.
 * Keeps `OurMenu.jsx` focused on layout and list behavior.
 */
export function OurMenuProductDetailModal({
  item,
  onClose,
  openIntent = null,
  editSession = null,
}) {
  if (!item) return null;
  return (
    <MenuItemModal
      item={item}
      onClose={onClose}
      openIntent={openIntent}
      editCartKey={editSession?.editCartKey ?? null}
      initialVariantId={editSession?.initialVariantId ?? null}
      initialAddOnIds={editSession?.initialAddOnIds ?? null}
      initialAddOnQtys={editSession?.initialAddOnQtys ?? null}
      initialQuantity={editSession?.initialQuantity ?? 1}
    />
  );
}
